import { useMemo } from "react"
import { UserModuleType } from "@tm/models"
import { useUser } from "../user"

export function useOffersModule() {
    const { userContext } = useUser()

    return useMemo(() => {
        const offerCarouselModule = userContext.modules?.find((x) => x.type === UserModuleType.OfferCarousel)
        const offerModule = userContext.modules?.find((x) => x.type === UserModuleType.Offers)

        const offerCarouselModuleDescription = offerCarouselModule?.parameters?.find((x) => x.key === "Description")?.value ?? "{{1276}}" // So the id can be seen in the browser
        const offerModuleDescription = offerModule?.parameters?.find((x) => x.key === "Description")?.value ?? "{{1276}}" // So the id can be seen in the browser

        return { offerCarouselModuleDescription, offerModuleDescription }
    }, [userContext])
}
